import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import BooksOutlineButton from '../common/buttons/BooksOutlineButton';
import BooksMenuDescription from '../model1/texts/BooksMenuDescription';
import css from './BooksMenuDescWithButton.module.scss';

interface Props extends React.HTMLProps<{}> {
  className?: string;
  text: string;
  postable: boolean;
  onClick?: (event: React.MouseEvent) => void;
  value?: number;
}

const BooksMenuDescWithButton = ({
  className,
  intl,
  text,
  postable,
  onClick,
  value,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksMenuDescWithButton, className);

  return (
    <div className={classes}>
      <BooksMenuDescription
        className={css.BooksMenuDescWithButton__Description}
        text={text}
      />
      <BooksOutlineButton
        className={css.BooksMenuDescWithButton__Button}
        disabled={!postable}
        onClick={onClick}
        value={value}
      >
        <span
          className={
            postable ? undefined : css.BooksMenuDescWithButton__Loading
          }
        >
          {intl.formatMessage({ id: 'books.button.select' })}
        </span>
      </BooksOutlineButton>
    </div>
  );
};

export default injectIntl(BooksMenuDescWithButton);
